import doc                 from '@widesk-core/decorators/doc';
import MapServiceModel     from '@/models/MapServiceModel';
import { downloadUrl }     from '@/helpers/DownloadHelper';
import { getBlob }         from '@/helpers/DownloadHelper';

@doc.path('/place_types/{id}/place_import_template')
export default class PlaceImportModel extends MapServiceModel {

	public async fetchBlob() {
		return getBlob(PlaceImportModel.connector.getUri({
			url: this.path
		}));
	}

	public async download(name?: string) {
		return downloadUrl(PlaceImportModel.connector.getUri({
			url: this.path
		}), name);
	}
	
}
